import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import { InputAdornment, TextField } from '@material-ui/core';
import { Lock } from '@material-ui/icons';
import '../../styles/LoginPage.scss';

type MyProps = {
  onClose: () => void;
  handleVerifyFactor: (passcode: string) => Promise<void>;
}

type MyState = {
  mfaCode: string,
}

class MFABox extends Component<MyProps, MyState> {

  constructor(props: any) {
    super(props);
    this.state = {
      mfaCode: '',
    };
  }

  render() {
    return (
      <div className="mfa-content">
        <div>
          <h3>Enter the code sent to your registered email</h3>
          <TextField
            type="text"
            placeholder="Enter code"
            margin="normal"
            variant="outlined"
            className="input-color"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Lock />
                </InputAdornment>
              )
            }}
            onChange={(e) => this.setState({ mfaCode: e.target.value })}
          />
        </div>
        <div className="button-container">
          <Button
            type="submit"
            name="continue"
            variant="contained"
            size="large"
            classes={{ label: 'button-label' }}
            className="button"
            onClick={() => this.props.handleVerifyFactor(this.state.mfaCode)}
          >
            Verify
          </Button>
        </div>
        <button className="back-button" onClick={this.props.onClose}>Back to Sign In</button>
      </div>
    );
  }
}

export default MFABox;